/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CurrencyInputs */

const en_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Currency`)
};

const es_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moneda`)
};

const fr_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devise`)
};

const de_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Währung`)
};

const ja_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通貨`)
};

const zh_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`货币`)
};

const ar_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العملة`)
};

const id_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mata Uang`)
};

const it_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valuta`)
};

const ru_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Валюта`)
};

const pt_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moeda`)
};

const ko_currency = /** @type {(inputs: CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`통화`)
};

/**
* | output |
* | --- |
* | "Currency" |
*
* @param {CurrencyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const currency = /** @type {((inputs?: CurrencyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CurrencyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_currency(inputs)
	if (locale === "es") return es_currency(inputs)
	if (locale === "fr") return fr_currency(inputs)
	if (locale === "de") return de_currency(inputs)
	if (locale === "ja") return ja_currency(inputs)
	if (locale === "zh") return zh_currency(inputs)
	if (locale === "ar") return ar_currency(inputs)
	if (locale === "id") return id_currency(inputs)
	if (locale === "it") return it_currency(inputs)
	if (locale === "ru") return ru_currency(inputs)
	if (locale === "pt") return pt_currency(inputs)
	return ko_currency(inputs)
});